import * as CONSTANTS from "../../../../actions/VideoMoreFromBaseSection/constants";
import { setData } from "../../util";

export const initialState = setData();

export default function extractMoreFromBaseSection(action) {
    switch (action.type) {
        case CONSTANTS.VIDEO_MORE_FROM_BASE_SECTION_UPDATE:
            return setData(action.payload);

        case CONSTANTS.VIDEO_MORE_FROM_BASE_SECTION_ERROR:
            return {
                items: [],
                isLoaded: true,
                errors: [action.payload],
            };

        case CONSTANTS.VIDEO_MORE_FROM_BASE_SECTION_NULL:
            return setData();

        default:
            // Nothing to see here, move along.
            return;
    }
}
